import { useAuth } from 'korint-sdk/react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { validateRedirectUrl } from '../../../utils/validate-redirect';

export const useOnAlreadyAuthenticated = () => {
  const { authStatus } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [query] = useSearchParams();

  useEffect(() => {
    if (authStatus === 'configuring') {
      setIsLoading(true);
    } else if (authStatus === 'authenticated') {
      const redirectUrl = query.get('redirect');
      // Validate redirect URL to prevent open redirect vulnerabilities
      const validatedRedirect = validateRedirectUrl(redirectUrl);
      const encodedRedirect = encodeURIComponent(validatedRedirect);
      const redirectSearch = `?redirect=${encodedRedirect}`;
      navigate(`/auth/me${redirectSearch}`, { replace: true });
    } else {
      setIsLoading(false);
    }
  }, [authStatus, query, navigate]);

  return { isLoading };
};
